(() => {
  const APP_SELECTOR = '#customer-exam-section';

  const ANALYZE_ENDPOINT =
    window.CustomerExamAnalyzeEndpoint ||
    'https://ouvirmelhor.dev.escolhadigital.com/api/customer-exam-analyze';

  
    function initializeCustomerExam(container = document) {
      const sections = [];

      if (container.matches && container.matches(APP_SELECTOR)) {
        sections.push(container);
      }

      sections.push(...container.querySelectorAll(APP_SELECTOR));

      sections.forEach(initCustomerExamSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeCustomerExam();
      });
    } else {
      initializeCustomerExam();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeCustomerExam(event.target);
    });


  function initCustomerExamSection(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const form = section.querySelector('#customer-exam-form');
    const dropzone = section.querySelector('#customer-exam-dropzone');
    const fileInput = section.querySelector('#customer-exam-file');
    const uploadTrigger = section.querySelector('#customer-exam-upload-trigger');
    const fileName = section.querySelector('#customer-exam-file-name');
    const message = section.querySelector('#customer-exam-message');

    const modeFileBtn = section.querySelector('#customer-exam-mode-file');
    const modeManualBtn = section.querySelector('#customer-exam-mode-manual');
    const filePanel = section.querySelector('#customer-exam-file-panel');
    const manualPanel = section.querySelector('#customer-exam-manual-panel');

    const observationsToggle = section.querySelector('#customer-exam-observations-toggle');
    const observationsPanel = section.querySelector('#customer-exam-observations-panel');

    const formShell = section.querySelector('.customer-exam-grid');
    const questionsPanel = section.querySelector('#customer-exam-questions');
    const continueArBtn = section.querySelector('#customer-exam-continue-ar');
    const answerButtons = section.querySelectorAll('.customer-exam-answer-btn');

    if (!form || !dropzone || !fileInput || !uploadTrigger || !fileName || !message) return;

    let currentMode = 'file';
    let analysisResult = null;
    const answers = {};

    const resultPanel = createResultPanel();

    if (modeFileBtn && modeManualBtn && filePanel && manualPanel) {
      modeFileBtn.addEventListener('click', () => setMode('file'));
      modeManualBtn.addEventListener('click', () => setMode('manual'));
    }

    if (observationsToggle && observationsPanel) {
      observationsToggle.addEventListener('click', () => {
        const isHidden = observationsPanel.classList.contains('customer-exam-hidden');
        observationsPanel.classList.toggle('customer-exam-hidden');
        observationsToggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      });
    }

    answerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = button.getAttribute('data-index');
        const value = button.getAttribute('data-value');

        answers[index] = value;

        const group = button.closest('.customer-exam-answer-group');
        if (group) {
          group.querySelectorAll('.customer-exam-answer-btn').forEach((btn) => {
            btn.classList.remove('is-active');
          });
        }

        button.classList.add('is-active');
        updateContinueButton();
      });
    });

    if (continueArBtn) {
      continueArBtn.addEventListener('click', async () => {
        await analyzeAndShowResult();
      });
    }

    fileInput.addEventListener('click', (event) => {
  event.stopPropagation();
});

    uploadTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (currentMode !== 'file') return;
      fileInput.click();
    });

    dropzone.addEventListener('click', (event) => {
      if (currentMode !== 'file') return;
      if (event.target === fileInput) return;
      if (event.target === uploadTrigger) return;
      if (event.target.closest('#customer-exam-upload-trigger')) return;

      fileInput.click();
    });

    dropzone.addEventListener('keydown', (event) => {
      if (currentMode !== 'file') return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        fileInput.click();
      }
    });

    fileInput.addEventListener('change', () => {
      updateSelectedFile(fileInput.files);
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        if (currentMode !== 'file') return;
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'dragend'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        if (currentMode !== 'file') return;
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', (event) => {
      if (currentMode !== 'file') return;

      event.preventDefault();
      event.stopPropagation();
      dropzone.classList.remove('is-dragover');

      const files = event.dataTransfer?.files;
      if (!files || !files.length) return;

      fileInput.files = files;
      updateSelectedFile(files);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      message.classList.add('customer-exam-hidden');
      message.textContent = '';

      if (!validateInitialForm()) return;

      showQuestionsStep();
    });

    function validateInitialForm() {
      const firstName = form.querySelector('[name="first_name"]');
      const lastName = form.querySelector('[name="last_name"]');
      const email = form.querySelector('[name="email"]');
      const consent = form.querySelector('[name="consent"]');

      if (!firstName.value.trim()) {
        showMessage('Por favor, introduza o seu nome.');
        firstName.focus();
        return false;
      }

      if (!lastName.value.trim()) {
        showMessage('Por favor, introduza o seu apelido.');
        lastName.focus();
        return false;
      }

      if (!isValidEmail(email.value)) {
        showMessage('Por favor, introduza um email válido.');
        email.focus();
        return false;
      }

      if (currentMode === 'file') {
        const file = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
        if (!file) {
          showMessage('Por favor, carregue um ficheiro ou escolha a opção de introdução manual.');
          return false;
        }
      }

      if (currentMode === 'manual') {
        const manualInputs = form.querySelectorAll('.customer-exam-manual-input');
        const hasAnyValue = Array.from(manualInputs).some((input) => String(input.value).trim() !== '');

        if (!hasAnyValue) {
          showMessage('Por favor, introduza pelo menos um valor manual do exame.');
          return false;
        }
      }

      if (!consent.checked) {
        showMessage('Tem de aceitar a política de privacidade para continuar.');
        consent.focus();
        return false;
      }

      return true;
    }

    function showQuestionsStep() {
      message.classList.add('customer-exam-hidden');
      message.textContent = '';

      if (formShell) {
        formShell.classList.add('customer-exam-hidden');
      }

      if (questionsPanel) {
        questionsPanel.classList.remove('customer-exam-hidden');

        setTimeout(() => {
          questionsPanel.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 80);
      }
    }

    function updateContinueButton() {
      if (!continueArBtn) return;

      const totalQuestions = section.querySelectorAll('.customer-exam-question-item').length;
      const totalAnswers = Object.keys(answers).length;

      continueArBtn.disabled = totalAnswers < totalQuestions;
    }

    async function analyzeAndShowResult() {
      if (!continueArBtn) return;

      continueArBtn.disabled = true;
      continueArBtn.classList.add('is-loading');

      const originalText = continueArBtn.querySelector('span')?.textContent || '';
      const firstSpan = continueArBtn.querySelector('span');

      if (firstSpan) {
        firstSpan.textContent = 'A analisar...';
      }

      try {
        const formData = buildAnalysisFormData();

        const response = await fetch(ANALYZE_ENDPOINT, {
          method: 'POST',
          body: formData
        });

        const json = await response.json().catch(() => null);

        if (!response.ok) {
          throw new Error(json?.error || 'Não foi possível analisar o exame.');
        }

        analysisResult = json;

console.log('RESULTADO COMPLETO DA API:', json);

saveExamDataToLocalStorage(json);
showResultStep(json);
      } catch (error) {
        showQuestionsError(error?.message || 'Erro ao analisar o exame.');
      } finally {
        continueArBtn.classList.remove('is-loading');

        if (firstSpan && originalText) {
          firstSpan.textContent = originalText;
        }

        updateContinueButton();
      }
    }

    function buildAnalysisFormData() {
      const formData = new FormData();

      formData.append('first_name', form.querySelector('[name="first_name"]')?.value || '');
      formData.append('last_name', form.querySelector('[name="last_name"]')?.value || '');
      formData.append('email', form.querySelector('[name="email"]')?.value || '');
      formData.append('consent', 'true');
      formData.append('mode', currentMode);

      if (currentMode === 'file') {
        const file = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
        if (file) {
          formData.append('exam_file', file);
        }
      }

      formData.append('manual_values', JSON.stringify(getManualValues()));

      // As perguntas servem para filtrar produtos no AR, não para influenciar a análise OpenAI.
      formData.append('questions', JSON.stringify([]));

      const observations = form.querySelector('[name="manual_observations"]')?.value || '';
      formData.append('manual_observations', observations);

      return formData;
    }

    function getManualValues() {
      const values = {
        left: {},
        right: {}
      };

      form.querySelectorAll('.customer-exam-manual-input').forEach((input) => {
        const name = input.getAttribute('name');
        const value = String(input.value || '').trim();

        if (!name || value === '') return;

        const match = name.match(/^manual_(left|right)_(ac|bc|ucl)_(\d+)$/);
        if (!match) return;

        const ear = match[1];
        const type = match[2];
        const frequency = match[3];

        if (!values[ear][frequency]) {
          values[ear][frequency] = {};
        }

        values[ear][frequency][type] = value;
      });

      return values;
    }

    function getQuestionsAndAnswers() {
      const result = [];

      section.querySelectorAll('.customer-exam-question-item').forEach((item) => {
        const index = item.getAttribute('data-question-index');
        const question = item.querySelector('.customer-exam-question-text')?.textContent?.trim() || '';

        result.push({
          index: Number(index),
          question,
          answer: answers[index] || ''
        });
      });

      return result;
    }

    function showQuestionsError(text) {
      let errorEl = questionsPanel?.querySelector('[data-questions-error]');

      if (!errorEl && questionsPanel) {
        errorEl = document.createElement('p');
        errorEl.setAttribute('data-questions-error', '');
        errorEl.style.marginTop = '18px';
        errorEl.style.color = '#B33D3D';
        errorEl.style.fontSize = '14px';
        errorEl.style.lineHeight = '1.5';
        questionsPanel.querySelector('.customer-exam-questions-actions')?.before(errorEl);
      }

      if (errorEl) {
        errorEl.textContent = text;
      }
    }
	
    function saveExamDataToLocalStorage(result) {
      if (!result || !result.exam_url) return;

      const examData = {
        exam_url: result.exam_url,
        uploaded_at: result.uploaded_at || null,
        saved_exam_file: result.saved_exam_file || null,

        // Perguntas e respostas do questionário
        questions_answers: getQuestionsAndAnswers(),

        hearing_level: result.hearing_level || null,
        pta_db: result.pta_db || null,

        left_hearing_level:
          result.left_hearing_level || null,

        left_pta_db:
          result.left_pta_db ?? null,

        right_hearing_level:
          result.right_hearing_level || null,

        right_pta_db:
          result.right_pta_db ?? null,

        better_ear:
          result.better_ear || null,

        worse_ear:
          getWorseEar(result),

        selected_ear: null,

        customer: {
          first_name:
            form.querySelector('[name="first_name"]')?.value || '',

          last_name:
            form.querySelector('[name="last_name"]')?.value || '',

          email:
            form.querySelector('[name="email"]')?.value || ''
        }
      };

      localStorage.setItem('ouvirmelhor_exam_data', JSON.stringify(examData));
    }

    function getWorseEar(result) {
      /*
      * Caso o backend já devolva explicitamente o ouvido pior,
      * usa esse valor.
      */
      const backendWorseEar = String(
        result?.worse_ear || result?.worseEar || ''
      )
        .trim()
        .toLowerCase();

      if (
        backendWorseEar === 'left' ||
        backendWorseEar === 'esquerdo' ||
        backendWorseEar === 'esquerda'
      ) {
        return 'Esquerdo';
      }

      if (
        backendWorseEar === 'right' ||
        backendWorseEar === 'direito' ||
        backendWorseEar === 'direita'
      ) {
        return 'Direito';
      }

      if (
        backendWorseEar === 'both' ||
        backendWorseEar === 'ambos' ||
        backendWorseEar === 'bilateral'
      ) {
        return 'Ambos';
      }

      /*
      * Caso o backend devolva PTA separado por ouvido,
      * compara os valores. Um PTA maior significa pior audição.
      */
      const pta = result?.pta_db;

      const leftPta = Number(
        pta?.left ??
        pta?.left_ear ??
        pta?.esquerdo ??
        result?.left_pta_db
      );

      const rightPta = Number(
        pta?.right ??
        pta?.right_ear ??
        pta?.direito ??
        result?.right_pta_db
      );

      const hasLeft = Number.isFinite(leftPta);
      const hasRight = Number.isFinite(rightPta);

      if (hasLeft && hasRight) {
        /*
        * Considera "Ambos" quando a diferença é igual ou inferior
        * a 5 dB. Podes alterar esta tolerância.
        */
        if (Math.abs(leftPta - rightPta) <= 5) {
          return 'Ambos';
        }

        return leftPta > rightPta ? 'Esquerdo' : 'Direito';
      }

      if (hasLeft) return 'Esquerdo';
      if (hasRight) return 'Direito';

      return '';
    }

    function normalizeHearingLevel(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function isProfoundLoss(level) {
      const normalized = normalizeHearingLevel(level);

      return (
        normalized.includes('perda profunda') ||
        normalized.includes('profunda') ||
        normalized.includes('cofose')
      );
    }

    function isSevereLoss(level) {
      const normalized = normalizeHearingLevel(level);

      return (
        normalized.includes('perda severa') ||
        normalized.includes('severa') ||
        normalized.includes('grave')
      );
    }

    function getRecommendationContext(result) {
      const leftLevel =
        result?.left_hearing_level ||
        result?.hearing_level ||
        '';

      const rightLevel =
        result?.right_hearing_level ||
        result?.hearing_level ||
        '';

      const leftProfound = isProfoundLoss(leftLevel);
      const rightProfound = isProfoundLoss(rightLevel);

      const perforation = answers['6'] === 'yes';

      /*
      * Caso 1:
      * ambos os ouvidos têm perda profunda.
      */
      if (leftProfound && rightProfound) {
        return {
          canRecommend: false,
          reason: 'profound_both',
          leftLevel,
          rightLevel
        };
      }

      /*
      * Ouvidos que podem efetivamente receber recomendação.
      * Perda profunda fica fora.
      */
      const usableEars = [];

      if (!leftProfound) {
        usableEars.push({
          ear: 'left',
          level: leftLevel
        });
      }

      if (!rightProfound) {
        usableEars.push({
          ear: 'right',
          level: rightLevel
        });
      }

      /*
      * Perfuração do tímpano implica miniBTE.
      *
      * A compatibilidade é avaliada apenas nos ouvidos
      * que podem efetivamente receber recomendação.
      *
      * Ouvidos com perda profunda já foram excluídos
      * de usableEars e não devem impedir a recomendação
      * para o outro ouvido.
      *
      * miniBTE não suporta perdas severas.
      */
      if (
        perforation &&
        usableEars.some((item) =>
          isSevereLoss(item.level)
        )
      ) {
        return {
          canRecommend: false,
          reason: 'perforation_incompatible',
          leftLevel,
          rightLevel
        };
      }

      const requires100 = usableEars.some((item) =>
        isSevereLoss(item.level)
      );

      /*
      * Tudo o que não é severo/profundo fica,
      * para já, no grupo 85.
      */
      const requires85 = usableEars.some((item) =>
        !isSevereLoss(item.level)
      );

      let selectedEar = '';

      if (usableEars.length === 2) {
        selectedEar = 'Ambos';
      } else if (usableEars[0]?.ear === 'left') {
        selectedEar = 'Esquerdo';
      } else if (usableEars[0]?.ear === 'right') {
        selectedEar = 'Direito';
      }

      return {
        canRecommend: usableEars.length > 0,

        leftLevel,
        rightLevel,

        leftProfound,
        rightProfound,

        requires85,
        requires100,

        selectedEar
      };
    }

    function showResultStep(result) {
      if (questionsPanel) {
        questionsPanel.classList.add('customer-exam-hidden');
      }

      const summary = result?.summary || '';

      const leftLevel =
        result?.left_hearing_level ||
        result?.hearing_level ||
        'Inconclusivo';

      const rightLevel =
        result?.right_hearing_level ||
        result?.hearing_level ||
        'Inconclusivo';

      const summaryEl =
        resultPanel.querySelector('[data-result-summary]');

      const leftLevelEl =
        resultPanel.querySelector('[data-result-level-left]');

      const rightLevelEl =
        resultPanel.querySelector('[data-result-level-right]');

      const continueButton =
        resultPanel.querySelector('[data-result-continue]');

      const warning =
        resultPanel.querySelector('[data-result-warning]');

      const context = getRecommendationContext(result);

      if (summaryEl) {
        summaryEl.textContent = summary;
        summaryEl.style.display = summary ? 'block' : 'none';
      }

      if (leftLevelEl) {
        leftLevelEl.textContent = leftLevel;
      }

      if (rightLevelEl) {
        rightLevelEl.textContent = rightLevel;
      }

      if (continueButton) {
        continueButton.style.display =
          context.canRecommend
            ? 'inline-flex'
            : 'none';
      }

      if (warning) {
        if (!context.canRecommend) {
          warning.style.display = 'block';

          if (context.reason === 'profound_both') {
            warning.innerHTML = `
              <strong>Não temos aparelhos adequados para este nível de perda auditiva.</strong>
              <span>
                Os resultados indicam perda auditiva profunda em ambos os ouvidos.
                Recomendamos que entre em contacto connosco para avaliarmos o seu caso.
              </span>

              <a href="/pages/contact">
                Entrar em contacto
              </a>
            `;
          } else {
            warning.innerHTML = `
              <strong>Não temos aparelhos adequados para esta combinação.</strong>
              <span>
                A indicação de perfuração do tímpano limita a recomendação a aparelhos miniBTE,
                que não são adequados para perdas severas ou profundas.
                Entre em contacto connosco para avaliarmos o seu caso.
              </span>

              <a href="/pages/contact">
                Entrar em contacto
              </a>
            `;
          }
        } else {
          warning.style.display = 'none';
          warning.innerHTML = '';
        }
      }

      resultPanel.classList.remove('customer-exam-hidden');

      setTimeout(() => {
        resultPanel.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 80);
    }

    function createResultPanel() {
      let panel = section.querySelector('#customer-exam-result');

      if (panel) return panel;

      panel = document.createElement('div');
      panel.id = 'customer-exam-result';
      panel.className = 'customer-exam-result customer-exam-hidden';

      panel.innerHTML = `
        <div class="customer-exam-shell">
          <div class="customer-exam-result-card">

            <p class="customer-exam-result-eyebrow">
              Resultado da análise
            </p>

            <p
              class="customer-exam-result-summary"
              data-result-summary
            ></p>

            <div class="customer-exam-ear-results">

              <div class="customer-exam-ear-result">
                <p class="customer-exam-ear-title">
                  Ouvido esquerdo
                </p>

                <div
                  class="customer-exam-result-level"
                  data-result-level-left
                >
                  —
                </div>
              </div>

              <div class="customer-exam-ear-result">
                <p class="customer-exam-ear-title">
                  Ouvido direito
                </p>

                <div
                  class="customer-exam-result-level"
                  data-result-level-right
                >
                  —
                </div>
              </div>

            </div>
            <div class="customer-exam-result-actions">
              <button
                type="button"
                class="customer-exam-ear-button"
                data-result-continue
              >
                <span>Ver aparelhos recomendados</span>
                <span class="customer-exam-continue-icon">→</span>
              </button>

              <div
                class="customer-exam-result-warning"
                data-result-warning
                style="display:none;"
              ></div>
            </div>
          </div>
        </div>
      `;

      const style = document.createElement('style');

      style.textContent = `
        #customer-exam-section .customer-exam-result {
          padding: 20px 0 64px;
        }

        #customer-exam-section .customer-exam-result-card {
          width: min(100%, 900px);
          margin: 0 auto;
          padding: 48px;
          border: 1px solid var(--exam-border);
          border-radius: 34px;
          background: rgba(255,255,255,0.55);
          text-align: center;
        }

        #customer-exam-section .customer-exam-result-eyebrow {
          margin: 0 0 22px;
          color: var(--exam-muted);
          font-size: 15px;
          line-height: 1.3;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.04em;
        }

        #customer-exam-section .customer-exam-result-summary {
          max-width: 720px;
          margin: 0 auto 38px;
          color: var(--exam-muted);
          font-size: 17px;
          line-height: 1.65;
          font-weight: 500;
        }

        #customer-exam-section .customer-exam-ear-results {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 28px;
          align-items: stretch;
        }

        #customer-exam-section .customer-exam-ear-result {
          display: flex;
          flex-direction: column;
          align-items: center;
          min-width: 0;
          padding: 30px 24px;
          border: 1px solid var(--exam-border);
          border-radius: 26px;
          background: rgba(255,255,255,0.45);
        }

        #customer-exam-section .customer-exam-ear-title {
          margin: 0 0 18px;
          color: var(--exam-text);
          font-size: 15px;
          line-height: 1.3;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.04em;
        }

        #customer-exam-section .customer-exam-result-level {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 58px;
          margin: 0 0 26px;
          padding: 14px 28px;
          border-radius: 999px;
          background: var(--exam-primary);
          color: #fff;
          font-size: clamp(18px, 2vw, 26px);
          line-height: 1.1;
          font-weight: 800;
          text-align: center;
        }

        #customer-exam-section .customer-exam-ear-button {
          appearance: none;
          border: 0;
          background: transparent;
          color: var(--exam-text);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: auto;
          padding: 0;
          font-size: 18px;
          line-height: 1.3;
          font-weight: 700;
          text-decoration: underline;
          cursor: pointer;
        }

        #customer-exam-section .customer-exam-continue-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 38px;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: var(--exam-primary);
          color: #fff;
          text-decoration: none;
          font-size: 19px;
          line-height: 1;
          transition:
            transform 0.2s ease,
            background-color 0.2s ease;
        }

        #customer-exam-section .customer-exam-ear-button:hover
        .customer-exam-continue-icon {
          transform: translateX(3px);
        }

        #customer-exam-section .customer-exam-result-actions {
          margin-top: 34px;
          text-align: center;
        }

        #customer-exam-section .customer-exam-result-warning {
          max-width: 720px;
          margin: 0 auto;
          padding: 24px;
          border: 1px solid #d8b4b4;
          border-radius: 20px;
          background: #fff6f6;
          color: var(--exam-text);
        }

        #customer-exam-section .customer-exam-result-warning strong {
          display: block;
          margin-bottom: 10px;
          font-size: 18px;
        }

        #customer-exam-section .customer-exam-result-warning span {
          display: block;
          color: var(--exam-muted);
          line-height: 1.6;
        }

        #customer-exam-section .customer-exam-result-warning a {
          display: inline-flex;
          margin-top: 18px;
          color: var(--exam-primary);
          font-weight: 700;
          text-decoration: underline;
        }

        @media screen and (max-width: 749px) {
          #customer-exam-section .customer-exam-result-card {
            padding: 34px 20px;
            border-radius: 26px;
          }

          #customer-exam-section .customer-exam-result-summary {
            margin-bottom: 28px;
            font-size: 15px;
          }

          #customer-exam-section .customer-exam-ear-results {
            grid-template-columns: 1fr;
            gap: 18px;
          }

          #customer-exam-section .customer-exam-ear-result {
            padding: 26px 18px;
            border-radius: 22px;
          }

          #customer-exam-section .customer-exam-result-level {
            min-height: 52px;
            margin-bottom: 22px;
            padding: 12px 22px;
            font-size: 19px;
          }

          #customer-exam-section .customer-exam-ear-button {
            font-size: 16px;
          }
        }
      `;

      section.appendChild(style);

      section
        .querySelector('.customer-exam-page-width')
        ?.appendChild(panel);

      panel
        .querySelector('[data-result-continue]')
        ?.addEventListener('click', () => {
          openARExperience();
        });

      return panel;
    }

    function getRecommendationOrder() {
      const q1 = answers['0'];
      const q2 = answers['1'];
      const q4 = answers['3'];
      const q5 = answers['4'];

      // Vida social ativa OU preferência por tecnologia avançada
      // => começar pela gama Premium
      if (q1 === 'yes' || q5 === 'yes') {
        return 'best_first';
      }

      // Sem prioridade Premium, mas frequenta ambientes ruidosos
      // OU pretende emparelhar com outros equipamentos
      // => começar pela gama Alta / Intermédia-Alta
      if (
        q1 === 'no' &&
        q5 === 'no' &&
        (q2 === 'yes' || q4 === 'yes')
      ) {
        return 'second_best_first';
      }

      // Nenhuma das condições anteriores
      // => começar pela gama de Entrada
      if (
        q1 === 'no' &&
        q2 === 'no' &&
        q4 === 'no' &&
        q5 === 'no'
      ) {
        return 'worst_first';
      }

      return 'best_first';
    }

    function saveRecommendationContextToLocalStorage(context) {
      try {
        const currentData = JSON.parse(
          localStorage.getItem('ouvirmelhor_exam_data') || '{}'
        );

        const updatedData = {
          ...currentData,

          selected_ear:
            context.selectedEar || null,

          requires_level_85:
            context.requires85 === true,

          requires_level_100:
            context.requires100 === true
        };

        localStorage.setItem(
          'ouvirmelhor_exam_data',
          JSON.stringify(updatedData)
        );
      } catch (error) {
        console.warn(
          'Não foi possível guardar o contexto da recomendação:',
          error
        );
      }
    }

    function openARExperience() {
      const sectionWrapper =
        section.closest('.shopify-section');

      const context =
        getRecommendationContext(analysisResult);

      if (!context.canRecommend) {
        return;
      }

      const productFilters = {
        batterySize:
          answers['2'] === 'yes'
            ? 'Bateria'
            : 'Pilhas',

        onlyMbteCategory:
          answers['6'] === 'yes',

        prioritizeZeal:
          answers['5'] === 'yes',

        recommendationOrder:
          getRecommendationOrder(),

        requires85:
          context.requires85,

        requires100:
          context.requires100
      };

      saveRecommendationContextToLocalStorage(context);

      section.classList.add('customer-exam-hidden');

      if (sectionWrapper) {
        sectionWrapper.style.display = 'none';
      }

      document.dispatchEvent(
        new CustomEvent('customer-exam:start-ar', {
          detail: {
            mode: currentMode,

            answers,
            productFilters,

            analysis: analysisResult,

            leftHearingLevel:
              context.leftLevel,

            rightHearingLevel:
              context.rightLevel,

            selectedEar:
              context.selectedEar,

            requires85:
              context.requires85,

            requires100:
              context.requires100
          }
        })
      );
    }

    function setMode(mode) {
      currentMode = mode;

      const isFile = mode === 'file';

      modeFileBtn.classList.toggle('is-active', isFile);
      modeManualBtn.classList.toggle('is-active', !isFile);

      modeFileBtn.setAttribute('aria-pressed', isFile ? 'true' : 'false');
      modeManualBtn.setAttribute('aria-pressed', !isFile ? 'true' : 'false');

      filePanel.classList.toggle('customer-exam-hidden', !isFile);
      manualPanel.classList.toggle('customer-exam-hidden', isFile);
    }

    function updateSelectedFile(files) {
      const file = files && files[0] ? files[0] : null;

      if (!file) {
        fileName.textContent = '';
        fileName.classList.add('customer-exam-hidden');
        return;
      }

      fileName.textContent = `Ficheiro selecionado: ${file.name}`;
      fileName.classList.remove('customer-exam-hidden');
    }

    function showMessage(text, isError = true) {
      message.textContent = text;
      message.style.color = isError ? '#B33D3D' : '#173A37';
      message.classList.remove('customer-exam-hidden');
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
    }
  }
})();